module.exports = __webpack_public_path__ + "img/pricing-splash.8eeae956.svg";